import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { retrieveExternalTeachers } from "./retrieve-external-teachers";
import type { ExternalTeacherVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

const initialState: RetrievalState<ExternalTeacherVM[]> = { fetching: "idle", data: [] };

export const retrieveExternalTeachersReducer = createReducer<RetrievalState<ExternalTeacherVM[]>>(initialState, builder => {
  builder
    .addCase(retrieveExternalTeachers.fulfilled, (state, { payload }) => {
      return { ...state, data: payload, fetching: "success" };
    })
    .addCase(retrieveExternalTeachers.pending, state => {
      return { ...state, fetching: "pending" };
    })
    .addCase(retrieveExternalTeachers.rejected, state => {
      return { ...state, fetching: "failed" };
    });
});
